import { __awaiter, __generator } from './../external_lib/tslib/tslib.es6.js';
import React__default, { useState, useEffect } from 'react';
import Geocode from './../external_lib/react-geocode/lib/index.js';
import Input from '../Atoms/Input.js';
import SearchIcon from '../assets/icons/search.icon.js';
import PinIcon from '../assets/icons/pin.icon.js';
import Typography from '../Atoms/Typography.js';
import _default from './../external_lib/react-google-autocomplete/lib/usePlacesAutocompleteService.js';
import MyLocation from '../assets/icons/my_location.icon.js';
import { FulfillmentType } from '../Enums/fulfillment_type.enum.js';
import HorizontalLoader from '../Atoms/HorizontalLoader.js';
import classNames from './../external_lib/classnames/index.js';
import { LazyMotion } from './../external_lib/framer-motion/dist/es/components/LazyMotion/index.js';
import { domAnimation } from './../external_lib/framer-motion/dist/es/render/dom/features-animation.js';
import { m } from './../external_lib/framer-motion/dist/es/render/dom/motion-minimal.js';

function GoogleLocation(_a) {
    var _this = this;
    var onLocationChange = _a.onLocationChange, googleApiKey = _a.googleApiKey, _b = _a.pastLocations, pastLocations = _b === void 0 ? [] : _b, ffType = _a.ffType;
    if (!googleApiKey) {
        return;
    }
    var _c = React__default.useState(null), userLocation = _c[0], setUserLocation = _c[1];
    var _d = React__default.useState(''), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(false), isGoogleLocationLoading = _e[0], setIsGoogleLocationLoading = _e[1];
    var _f = _default({
        apiKey: googleApiKey,
        sessionToken: true
    }), placesService = _f.placesService, placePredictions = _f.placePredictions, getPlacePredictions = _f.getPlacePredictions, isPlacePredictionsLoading = _f.isPlacePredictionsLoading, autocompleteSessionToken = _f.autocompleteSessionToken;
    Geocode.setApiKey(googleApiKey);
    var userLocationError = userLocation && !(userLocation === null || userLocation === void 0 ? void 0 : userLocation.success);
    var searchLocation = function (location) {
        setInputValue(location.target.value);
        if (location.target.value.trim()) {
            getPlacePredictions({
                input: location.target.value,
                sessionToken: autocompleteSessionToken
            });
        }
    };
    var selectPlace = function (placeId) {
        placesService.getDetails({
            placeId: placeId,
            sessionToken: autocompleteSessionToken
        }, function (place, status) {
            if (status === 'OK' && typeof onLocationChange === 'function') {
                var address = "".concat(place.name, ", ").concat(place.formatted_address);
                onLocationChange(placeId, place.geometry.location.lat(), place.geometry.location.lng(), address);
            }
        });
    };
    var getPlaceDetailsFromLatLng = function (lat, lng) { return __awaiter(_this, void 0, void 0, function () {
        var address, placeId, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = '';
                    placeId = '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Geocode.fromLatLng(lat, lng)];
                case 2:
                    response = _a.sent();
                    address = response.results[0].formatted_address;
                    placeId = response.results[0].place_id;
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 4: return [2 /*return*/, { address: address, placeId: placeId }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getCurrentLocation = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            setIsGoogleLocationLoading(true);
            navigator.geolocation.getCurrentPosition(function (position) { return __awaiter(_this, void 0, void 0, function () {
                var placeDetailsFromLatLng;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setIsGoogleLocationLoading(false);
                            return [4 /*yield*/, getPlaceDetailsFromLatLng(position.coords.latitude, position.coords.longitude)];
                        case 1:
                            placeDetailsFromLatLng = _a.sent();
                            setUserLocation({
                                success: true,
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            });
                            onLocationChange(placeDetailsFromLatLng.placeId, position.coords.latitude, position.coords.longitude, placeDetailsFromLatLng.address);
                            return [2 /*return*/];
                    }
                });
            }); }, function () {
                setIsGoogleLocationLoading(false);
                setUserLocation({
                    success: false
                });
            }, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        setIsGoogleLocationLoading(isPlacePredictionsLoading);
    }, [isPlacePredictionsLoading]);
    var animation = {
        hide: {
            opacity: 0,
            y: -50
        },
        show: {
            opacity: 1,
            y: 0
        }
    };
    var parentAnimation = {
        hide: {
            opacity: 0
        },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.07,
                delayChildren: 0.2
            }
        }
    };
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: "location_search__tab" },
            React__default.createElement(Input, { placeholder: "Search for any location", leftIcon: React__default.createElement(SearchIcon, null), onChange: searchLocation, value: inputValue }),
            React__default.createElement(HorizontalLoader, { classes: classNames('location__horizontal-loader', {
                    'location__horizontal-loader--visible': isGoogleLocationLoading
                }) })),
        placePredictions.length === 0 && !inputValue.trim() && (React__default.createElement("a", { onClick: getCurrentLocation, className: "location_search__pointer" },
            React__default.createElement("div", { className: "location_search__current" }, !userLocationError && (React__default.createElement("div", { className: "location_search__current__title" },
                React__default.createElement(MyLocation, null),
                React__default.createElement(Typography, { variant: "bodyTextTwo" }, "Use your current location")))))),
        React__default.createElement("div", { className: ffType === FulfillmentType.pickup
                ? 'location_search__suggestions--pickup'
                : 'location_search__suggestions' },
            React__default.createElement(LazyMotion, { features: domAnimation },
                React__default.createElement(m.div, { animate: placePredictions.length ? 'show' : 'hide', variants: parentAnimation }, placePredictions === null || placePredictions === void 0 ? void 0 : placePredictions.map(function (prediction) { return (React__default.createElement("a", { onClick: function () { return selectPlace(prediction.place_id); }, className: "location_search__pointer" },
                    React__default.createElement(m.div, { variants: animation, className: "location_search__suggestion__card", key: prediction.place_id, layoutId: "place_".concat(prediction.place_id) },
                        React__default.createElement("div", { className: "location_search__suggestion__icon" },
                            React__default.createElement(PinIcon, null)),
                        React__default.createElement("div", { className: "location_search__suggestion__title" },
                            React__default.createElement(Typography, { variant: "bodyTextOne" }, prediction.structured_formatting.main_text),
                            React__default.createElement(Typography, { variant: "bodyTextTwo", classes: "location_search__suggestion__overflow" }, prediction.structured_formatting.secondary_text))))); }))),
            !(placePredictions === null || placePredictions === void 0 ? void 0 : placePredictions.length) && (pastLocations === null || pastLocations === void 0 ? void 0 : pastLocations.length) > 0 && (React__default.createElement("div", { className: "location_search__past_locations" },
                React__default.createElement(Typography, { variant: "bodyTextOne", classes: "location_search__past_locations__title" }, ffType === FulfillmentType.pickup
                    ? 'Recent Locations'
                    : 'Saved Addresses'), pastLocations === null || pastLocations === void 0 ? void 0 :
                pastLocations.map(function (prediction, index) {
                    var _a, _b, _c, _d;
                    return (React__default.createElement("a", { onClick: function () {
                            return onLocationChange(prediction.placeId, prediction.latitude, prediction.longitude, prediction.address);
                        }, className: "location_search__pointer", key: index },
                        React__default.createElement("div", { className: "location_search__suggestion", key: "past-location-".concat(index) },
                            React__default.createElement("div", { className: "location_search__suggestion__icon" },
                                React__default.createElement(PinIcon, null)),
                            React__default.createElement("div", { className: "location_search__suggestion__title" },
                                React__default.createElement(Typography, { variant: "bodyTextOne" }, (_b = (_a = prediction.address.split(/,(.*)/g)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.trim()),
                                React__default.createElement(Typography, { variant: "bodyTextTwo", classes: "location_search__suggestion__overflow" }, (_d = (_c = prediction.address.split(/,(.*)/g)) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.trim())))));
                }))))));
}

export { GoogleLocation as default };
//# sourceMappingURL=GoogleLocation.js.map
